import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Unsubscriber } from '@core-lib/classes';
import { ActionType } from '@core-lib/enums';
import { IAction, IConfirmModalConfig } from '@core-lib/models';
import { ModalRef } from '@core-lib/modules/modal-container';

@Component({
    selector: 'confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    standalone: false
})
export class ConfirmationModalComponent extends Unsubscriber {
	private _config: IConfirmModalConfig = { textsKey: 'ConfirmModal', modalOptions: { backdrop: 'static' } };
	// BUG 13638 - Parfois, on affiche un modal vide avec la configuration par défaut.
	// Pour sécuriser l'affichage, on ajoute ce flag afin de s'assurer que la configuration est correctement chargée avant d'afficher le modal.
	isConfigLoaded: boolean = false;

	@Input() set config(config: IConfirmModalConfig) {
		if (config) {
			this._config = {
				cancelBtnText: 'Actions.Cancel',
				confirmBtnText: 'Actions.Confirm',
				canClose: true,
				canConfirm: true,
				...config
			};
			this.isConfigLoaded = true;
		} else {
			this.isConfigLoaded = false;
		}
	}

	get config(): IConfirmModalConfig {
		return this._config;
	}

	@Output() action: EventEmitter<IAction> = new EventEmitter();

	constructor(private modalRef: ModalRef) {
		super();
	}

	onClose(): void {
		this.action.emit({ type: ActionType.Close });
		this.modalRef.hide();
	}

	onConfirm(): void {
		this.action.emit({ type: ActionType.Confirm });
	}
}
